import {FormioBase} from "./formiobase";

export class Select extends FormioBase {
  public inputType = "select";
  public title = "Select";
  public icon = "fa fa-th-list";
  public shouldBeRenderedByFormio = false;
  public data: any;
  public schema: any = {
    title: "select",
    components: [{
      input: true,
      inputType: "select",
      tableView: true,
      label: "Select",
      key: "selectboxkey",
      placeholder: "",
      data: {
        values: [],
        json: "",
        url: "",
        resource: "",
        custom: "",
      },
      dataSrc: "values",
      valueProperty: "",
      defaultValue: "",
      refreshOn: "",
      filter: "",
      authenticate: false,
      template: "<span>{{ item.label }}</span>",
      multiple: false,
      protected: false,
      unique: false,
      persistent: true,
      hidden: false,
      clearOnHide: true,
      validate: {
        required: false,
      },
      type: "select",
      tags: [],
      tooltip: "",
      customClass: "ds-select",
    }],
  };
}
